exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".actionIntro[data-v-5d7eb81e]{background:#fafafa;border:1px solid #eef1f6;list-style:inside disc}.actionIntro li[data-v-5d7eb81e]{line-height:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-5d7eb81e","scoped":true,"hasInlineConfig":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/Student.vue
// module id = 541
// module chunks = 1